import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ReserveProvider } from '../providers/reserves';

@Pipe({
  name: 'reserveUserData'
})

export class ReserveDataPipe implements PipeTransform {

  constructor(
    private reserveData: ReserveProvider
  ) { }

  transform(reserveUser: any): Observable<any> {
    return this.reserveData.getReserveData(reserveUser.reserveId);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/reserveData.pipe.ts